import * as types from '../constants/meetingdetails'

const initialState = {
  Status: null,
  apiGetResult: null,
  apiPostResult: null,
  meetingdetails: null,
  meetingdetailsList: null,
  switchmeetingdetailsList: null
}

export function meetingDetails(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_MEETING_REQUEST:
      return {
        ...state,
        Status: true,
        meetingdetails: null,
        apiGetResult: null,
      };
    case types.FETCH_MEETING_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        meetingdetails: action.data
      };
    case types.FETCH_MEETING_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // meetingdetailsList:action.error
      };
    case types.FETCH_MEETING_RESET:
      return {
        ...state,
        Status: null,
        apiGetResult: null,
        meetingdetailsList: null,
        meetingdetails: null,
      };
    case types.FETCH_MEETING_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_MEETING_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        meetingdetailsList: action.data
      };
    case types.FETCH_MEETING_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false,
        // meetingdetailsList:action.error
      };
    case types.FETCH_SWITCH_MEETING_LIST_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.FETCH_SWITCH_MEETING_LIST_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiGetResult: true,
        switchmeetingdetailsList: action.data
      };
    case types.FETCH_SWITCH_MEETING_LIST_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiGetResult: false
      };
    case types.ADD_MEETING_RESET:
      return {
        ...initialState,
        Status: null,
        apiPostResult: null
      };
    case types.ADD_MEETING_REQUEST:
      return {
        ...state,
        Status: true
      };
    case types.ADD_MEETING_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_MEETING_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };

    case types.ADD_MEETING_MINUTES_FILE_REQUEST:
      return {
        ...state,
        Status: true
      };

    case types.ADD_MEETING_MINUTES_FILE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.ADD_MEETING_MINUTES_FILE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    case types.UPDATE_MM_FILE_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.UPDATE_MM_FILE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.UPDATE_MM_FILE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    case types.DELETE_MM_FILE_REQUEST:
      return {
        ...initialState,
        Status: true
      };
    case types.DELETE_MM_FILE_REQUEST_COMPLETED:
      return {
        ...state,
        Status: false,
        apiPostResult: true
      };
    case types.DELETE_MM_FILE_REQUEST_ERROR:
      return {
        ...state,
        Status: false,
        apiPostResult: false
      };
    default:
      return state;
  }
} 


// WEBPACK FOOTER //
// ./reducers/meetingdetails.js